import script from "./AdminBanners.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBanners.vue?vue&type=script&setup=true&lang=js"

import "./AdminBanners.vue?vue&type=style&index=0&id=2ea8264a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea8264a"]])

export default __exports__